<template>
  <div v-if="isBranded()">
    <ul class="nav intro-nav">
      <li class="nav-item">
        <a
          :class="{ active: filterquery === 'all' }"
          class="nav-link"
          href="#"
          @click.prevent="updateQuery('all')"
        >{{ $t('message.all') }}</a>
      </li>
      <li class="nav-item">
        <a
          :class="{ active: filterquery === 'nearby' }"
          class="nav-link"
          href="#"
          @click.prevent="updateQuery('nearby')"
        >{{ $t('message.nearMe') }}</a>
      </li>
      <li v-show="false" class="nav-item">
        <a class="nav-link" href="#">{{ $t('message.new') }}</a>
      </li>
    </ul>
    <div class="p-4">
      <resturants-filter :filter-query="filterquery" />
    </div>
  </div>
  <div v-else class="row mt-5">
    <div class="col-md-12 mt-5">
      <h2 class="text-center">{{ $t('message.welcomeAabcusOnlineOrdering') }}</h2>
    </div>
  </div>
</template>

<script>
import ResturantsFilter from "./ResturantsFilter";
import shared from "../../../sharedscripts/master/Resturant/Resturants.js";
import { mapMutations } from "vuex";
export default {
  name: "Resturants",
  components: {
    ResturantsFilter
  },
  data() {
    return {
      ...shared.data()
    };
  },
  methods: {
    ...shared.methods,
    ...mapMutations(["setStoreLoaded"])
  },
  created() {
    if (!this.isBranded()) {
      this.setStoreLoaded();
    }
  }
};
</script>

